import client from './client';

// Returns object keyed by siteId: { [siteId]: eventRow }
export async function listActive() {
  const { data } = await client.get('/api/events/active');
  return data;
}

export async function start(body)         { const { data } = await client.post('/api/events/start', body); return data; }
export async function end(siteId)         { const { data } = await client.delete(`/api/events/${siteId}`); return data; }
export async function resetStatus(siteId) { const { data } = await client.post(`/api/events/${siteId}/reset-status`); return data; }
